import React, { useEffect } from 'react';
import { Button, LinearProgress, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { clsx } from 'clsx';
import { useAppDispatch, useAppSelector } from '../../Store/hooks';
import { SelectShipment } from '../../Store/Selectors';
import { setShipmentNumber, loadTrackingStatus, checkPostCodeSuccess,resetStatus } from '../../Store/Slices';
import './shipment-input.component.scss';
import { getQueryParam } from '../../utils';

export const ShipmentInputComponent: React.FC = () => {
  const shipmentState = useAppSelector(SelectShipment);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const sendungsNummber = getQueryParam('sendung');
    if (!sendungsNummber?.length) return;
    dispatch(setShipmentNumber(sendungsNummber));
    dispatch(loadTrackingStatus(sendungsNummber));
  }, []);

  const handleSearch = () => dispatch(loadTrackingStatus(shipmentState.shipmentNumber));
  const setShipment = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    dispatch(setShipmentNumber(e.target.value))
    dispatch(resetStatus())
  }

  return (
    <div className="position-relative">
      <div className="d-flex justify-content-center flex-row gap-1">
        <TextField
          className="shipment-input  shipment-input-short"
          size={'medium'}
          label="Sendungsnummer"
          variant="outlined"
          disabled={shipmentState.loading}
          value={shipmentState.shipmentNumber}
          onChange={setShipment}
          onKeyUp={(e) => e.key === 'Enter' && handleSearch()}
          InputProps={{
            endAdornment: (
              <Button
                variant="contained"
                size="large"
                disabled={shipmentState.loading}
                onClick={() => handleSearch()}>
                <SearchIcon />
              </Button>
            )
          }}
        />
      </div>
      <div className="d-flex justify-content-center flex-row gap-1">
        <span
          className="mt-3 text-center"
          style={{ color: 'var(--primary-color)', fontWeight: '500' }}>
          Für Geschäftskunden:&nbsp;
          <a className="business-link" href="https://sendungsstatus.pin-ag.de">
            Erweiterte Sendungsverfolgung
          </a>
        </span>
      </div>
      <LinearProgress
        className={clsx([
          'shipment-loading mt-1',
          { 'shipment-loading-visible': shipmentState.loading }
        ])}
        color="success"
      />
    </div>
  );
};
